import * as ZapparThree from '@zappar/zappar-threejs'
import * as THREE from 'three'

import Camera from './Camera'
import Renderer from './Renderer'
import World from './World'
import Light from './Light'
import Config from './Utils/Config'
import EventEmitter from './Utils/EventEmitter'
import NavigationManager from './Utils/NavigationManager'

// import { Pane } from 'tweakpane'

import { ExperienceOptions } from '../config/types'

class Experience {
  static instance: Experience

  private isRunning = false

  public clock = new THREE.Clock()

  public navigationManager!: NavigationManager

  public eventEmitter!: EventEmitter
  public targetElement!: HTMLDivElement
  public config!: Config

  public scene!: THREE.Scene
  public sceneOrtho!: THREE.Scene

  public renderer!: Renderer
  public camera!: Camera
  public light!: Light
  public world!: World

  // public pointlight!: THREE.PointLight

  constructor(options?: ExperienceOptions) {
    // :: AR compatibility check ::.
    if (ZapparThree.browserIncompatible()) {
      ZapparThree.browserIncompatibleUI()
      throw new Error('Unsupported browser')
    }

    // :: Singleton pattern ::
    if (Experience.instance) {
      return Experience.instance
    }
    Experience.instance = this

    if (!options?.targetElement) {
      console.warn("Missing 'targetElement' property")
      return
    }

    // :: DOM ::
    this.targetElement = options?.targetElement

    // :: Init. experience ::
    this.navigationManager = new NavigationManager()

    this.setScene()
    this.setConfig()
    this.setCamera()
    this.setRenderer()
    this.setEventEmitter()
    // this.setLight()
    this.setWorld()
    this.setResize()

    this.isRunning = true

    console.log('Starting experience...')
    this.update()
  }

  private setEventEmitter() {
    this.eventEmitter = new EventEmitter()
  }

  private setWorld() {
    this.world = new World()
  }

  private setCamera() {
    this.camera = new Camera()
    this.camera.start()
    this.scene.background = this.camera.zapparCamera.backgroundTexture
  }

  private setLight() {
    new Light()
    // const hemiLight = new THREE.HemisphereLight(0xffeeb1, 0x080820, 6)
    // this.scene.add(hemiLight)
    // const spotlight = new THREE.SpotLight(0xffa95c, 4)
    // spotlight.position.set(0, 0, 1.0)
    // // spotlight.castShadow = true
    // this.scene.add(spotlight)
    // this.light = new Light()
    // this.pointlight = new THREE.PointLight('#ffffff', 68.0)
    // We want it to be very close to our character
    // this.pointlight.position.set(0.0, 1.0, 1.0)
    // this.scene.add(this.pointlight)
    // const pane = new Pane({ title: 'Shark ' })
    // const pointlightF = pane.addFolder({
    //   title: 'Point Light',
    // })
    // pointlightF.addInput(pointlight, 'intensity', {
    //   max: 200,
    //   min: 0,
    //   step: 0.001,
    // })
    // pointlightF.addInput(pointlight, 'distance', {
    //   max: 200,
    //   min: 0,
    //   step: 0.001,
    // })
    // pointlightF.addInput(pointlight, 'decay', { max: 200, min: 0, step: 0.001 })
    // pointlightF.addInput(pointlight, 'color')
  }

  private setConfig() {
    this.config = new Config()
  }

  private setScene() {
    this.scene = new THREE.Scene()
    this.sceneOrtho = new THREE.Scene()
  }

  private setResize() {
    window.addEventListener('resize', () => {
      const boundings = this.targetElement.getBoundingClientRect()
      this.config.screen.width = boundings.width || window.innerWidth
      this.config.screen.height = boundings.height || window.innerHeight

      this.camera.resize()
      this.world.resize()
      this.renderer.resize()
    })
  }

  private setRenderer() {
    this.renderer = new Renderer()
    this.targetElement.appendChild(this.renderer.instance.domElement)
    ZapparThree.glContextSet(this.renderer.instance.getContext())
  }

  private update() {
    if (this.isRunning) {
      this.camera?.update()
      this.renderer?.update()

      requestAnimationFrame(this.update.bind(this))

      this.world?.update()
    }
  }

  public navigation(step: number) {
    this.navigationManager?.update(step)
  }

  public destroy() {
    this.stop()
    this.world?.destroy()
  }

  public stop() {
    this.camera.start()
    this.isRunning = false
  }
}

export default Experience
